import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatCurrency, formatDateTime } from "../lib/api";
import PageHeader from "../components/PageHeader";
import StatusBadge from "../components/StatusBadge";

const LiveRides = () => {
    const [rides, setRides] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchLive = () => {
        api.get("/rides/live").then((r) => { setRides(r.data); setLoading(false); });
    };

    useEffect(() => {
        fetchLive();
        const interval = setInterval(fetchLive, 10000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="space-y-6">
            <PageHeader
                title="Live Rides"
                subtitle={`${rides.length} active rides · auto-refreshes every 10s`}
                action={
                    <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-mint-50 border border-mint-200">
                        <span className="relative w-2 h-2 rounded-full bg-mint-500 dot-pulse" />
                        <span className="text-xs font-semibold text-mint-700">LIVE</span>
                    </div>
                }
            />

            {loading ? (
                <div className="text-slate-500">Loading…</div>
            ) : rides.length === 0 ? (
                <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center text-slate-400">
                    No active rides right now.
                </div>
            ) : (
                <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
                    {rides.map((r) => (
                        <Link
                            key={r.id}
                            to={`/rides/${r.id}`}
                            className="bg-white border border-slate-200 rounded-2xl p-5 hover:border-mint-300 hover:shadow-sm transition-all"
                            data-testid={`live-ride-card-${r.id}`}
                        >
                            <div className="flex items-center justify-between mb-3">
                                <div className="text-sm font-semibold text-mint-600">{r.id}</div>
                                <StatusBadge status={r.status} />
                            </div>
                            <div className="text-xs text-slate-500 mb-1">Customer</div>
                            <div className="text-sm font-semibold text-navy-900 mb-3">{r.customer?.name || "—"}</div>

                            <div className="text-xs text-slate-500 mb-1">Driver · {r.vehicle_type}</div>
                            <div className="text-sm font-semibold text-navy-900 mb-3">{r.driver?.name || "Unassigned"}</div>

                            <div className="text-sm text-slate-600">
                                <div className="truncate">📍 {r.pickup_address}</div>
                                <div className="truncate">🎯 {r.drop_address}</div>
                            </div>

                            <div className="mt-4 pt-4 border-t border-slate-100 flex items-center justify-between text-sm">
                                <span className="text-slate-500">{r.distance_km} km · {r.duration_min} min</span>
                                <span className="font-display font-bold text-navy-900">{formatCurrency(r.fare)}</span>
                            </div>
                            <div className="text-[11px] text-slate-400 mt-2">{formatDateTime(r.created_at)}</div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LiveRides;
